import AnalogInstrument from "@/pages/portal/tools/AnalogInstrument";

export default function ORS() {
  return <AnalogInstrument kind="ors" />;
}
